// External
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

export const NotFoundError = () => (
  <div className="mt-10 flex flex-col items-center justify-center">
    <HelpOutlineIcon style={{ fontSize: 128, color: '#9E9E9E' }} />
    <p>We can't find the page you're looking for. Please try again later.</p>
  </div>
);
